import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ApplicationAddressPage, AddActionModal } from './application-address';

@NgModule({
  declarations: [
    ApplicationAddressPage,
    AddActionModal
  ],
  imports: [
    IonicPageModule.forChild(ApplicationAddressPage),
  ],
  entryComponents:[
    AddActionModal
  ]
  
})
export class ApplicationAddressPageModule {}



// WEBPACK FOOTER //
// ./src/pages/new-account/bank-new-account/application-address/application-address.module.ts